import { isFuture } from 'date-fns';
import {
  RateChangeFormValues,
  RateChangeFormViolation,
} from 'types/rateChangeFormTypes';
import { createM8RateDTO } from 'utils/m8RateDTOUtils';
import { createUniqueRuntimeNumber } from 'utils/uniqueRuntimeNumberUtils';

export const createRateChangeFormValues = (): RateChangeFormValues => ({
  m8RateDTO: createM8RateDTO(createUniqueRuntimeNumber()),
  nextDateOn: null,
});

export const validateRateChangeFormValues = (
  values: RateChangeFormValues
): RateChangeFormViolation[] => {
  const violations: RateChangeFormViolation[] = [];

  if (!values.nextDateOn) {
    violations.push({
      name: 'NextDateOnMissed',
    });
  }

  if (values.nextDateOn && isFuture(new Date(values.nextDateOn))) {
    violations.push({
      name: 'NextDateOnIsFuture',
    });
  }

  return violations;
};
